import React from "react";
import { Tooltip, IconButton, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { BRAND_GREEN_70 } from "./colors";

interface InfoTooltipProps {
    title: string;
    compact?: boolean;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ title, compact = false }) => {
    const paragraphs = title.split("\n\n");
    const formattedContent = (
        <>
            {paragraphs.map((paragraph, index) => (
                <Typography
                    key={`tooltip-paragraph-${paragraph.slice(0, 20).replace(/\s/g, "-")}`}
                    variant="body2"
                    style={{
                        marginBottom: index < paragraphs.length - 1 ? "8px" : 0,
                        fontSize: "0.8rem",
                        whiteSpace: "pre-line"
                    }}
                >
                    {paragraph}
                </Typography>
            ))}
        </>
    );
    return (
        <Tooltip title={formattedContent} arrow placement="top" sx={{ maxWidth: 350 }}>
            <IconButton
                size="small"
                sx={{
                    color: BRAND_GREEN_70,
                    marginLeft: "4px",
                    verticalAlign: "middle",
                    width: "1.25rem !important",
                    height: "1.25rem !important",
                    minWidth: "1.25rem !important",
                    minHeight: "1.25rem !important",
                    fontSize: "1.25rem !important",
                    ...(compact ? { padding: "0.01rem !important", marginBottom: "0.25rem !important" } : {})
                }}
            >
                <InfoIcon sx={{ fontSize: "1.25rem" }} />
            </IconButton>
        </Tooltip>
    );
};

export default InfoTooltip;
